export const TYPE_RECOMMENDED = 'recommended';
export const TYPE_SELECTED = 'selected';
export const TYPE_SAVED = 'saved';
export const CATEGORY_HAIRCARE = 'hairCare';
export const CATEGORY_SCALPCARE = 'scalpCare';
export const CATEGORY_HAIR_SCALP_CARE = 'hairScalpCare';



// WEBPACK FOOTER //
// ./src/pages/SalonConsultationPage/SublimicDiagnosisResultPage/CareMenuImage/CareMenuImageConst.js